/** Cifras y textos legales/comerciales de CP que se repiten en varios lugares (Términos, Política, sitio público,
 *  consentimiento de salud, script de purga de leads). Una sola fuente: `scripts/test-politicas-legal.ts` comprueba
 *  que los textos publicados y el script de purga digan lo mismo que estas constantes.
 *  Decisiones del dueño del 2026-10-31. Los textos son BORRADOR hasta el visto bueno de la abogada
 *  (ver docs/legal/para-la-abogada-2026-10.md). */

/** Duración de la clase gratis (evaluación inicial presencial): rango en minutos. Sin tarjeta ni cobro. */
export const CLASE_GRATIS_MIN = { desde: 30, hasta: 45 } as const;

/** Días de conservación de un lead frío (sin contacto y sin inscripción) antes de borrarlo. Se cuentan desde el último contacto. */
export const LEAD_RETENCION_DIAS = 180;

/** Plazo del derecho de retracto en contratación a distancia (Términos 6.3). Pendiente de confirmar por la abogada. */
export const RETRACTO_DIAS = 10;

/** Plazo para recuperar una clase cancelada por CP o por el profesor (Términos 6.3). Decisión del dueño. */
export const RECUPERACION_CLASES_DIAS = 30;

/** Días que se conserva la ficha de un alumno eliminado antes de anonimizarla (igual a STUDENT_PAPELERA_RETENTION_DAYS). */
export const SALUD_CONSERVACION_TRAS_BAJA_DIAS = 14;

/** Versión del texto del consentimiento de salud. «borrador-…» hasta que la abogada lo valide; entonces se pasa a «1.0».
 *  Cambiar el texto obliga a cambiar esta versión (se guarda con cada consentimiento). */
export const SALUD_CONSENT_VERSION = "borrador-2026-10-31";

/** Texto que ve la persona en el Portal (ella misma consiente). */
export const SALUD_CONSENT_TEXTO_ALUMNO =
  "Autorizo a Calistenia Progresiva a registrar la información de salud que indico (lesiones, molestias o condiciones) " +
  "solo para adaptar mis ejercicios de forma segura. La verán únicamente mi profesor y la administración. " +
  `La conservan mientras yo sea alumno y, si mi ficha se elimina, ${SALUD_CONSERVACION_TRAS_BAJA_DIAS} días más; después se borra o se anonimiza. ` +
  "Puedo acceder, corregir, eliminar u oponerme escribiendo a contacto@cprogresiva.cl, y retirar esta autorización cuando quiera sin perder el acceso a las clases.";

/** Texto que lee el profesor a la persona (o a su apoderado, si es menor de 16) durante la evaluación. */
export function saludConsentTextoEvaluacion(menorDe16: boolean): string {
  const quien = menorDe16 ? "La madre, el padre o el apoderado autoriza" : "La persona autoriza";
  const suyo = menorDe16 ? "del niño, niña o adolescente" : "suya";
  return (
    `${quien} a Calistenia Progresiva a registrar la información de salud ${suyo} (lesiones, molestias o condiciones) ` +
    "solo para adaptar los ejercicios de forma segura. La verán únicamente el profesor y la administración. " +
    `Si no se inscribe, se borra a los ${LEAD_RETENCION_DIAS} días desde el último contacto; si se inscribe, se conserva mientras sea alumno y ${SALUD_CONSERVACION_TRAS_BAJA_DIAS} días más tras eliminar su ficha. ` +
    "Puede acceder, corregir, eliminar u oponerse escribiendo a contacto@cprogresiva.cl, y retirar la autorización cuando quiera sin perder el acceso a las clases."
  );
}

/** Menor de 16: el consentimiento lo da su apoderado (regla acordada, falta confirmar edad exacta con la abogada). */
export const EDAD_CONSENTIMIENTO_PROPIO = 16;

/** Texto público de la clase gratis (plan grupal). */
export const CLASE_GRATIS_PERK =
  `Primera clase gratis: dura de ${CLASE_GRATIS_MIN.desde} a ${CLASE_GRATIS_MIN.hasta} minutos, una por persona, sujeta a cupo. Sin tarjeta ni cobro`;

/** Promedio de notas que se pide para el descuento de estudiante (docs/ventas/politicas-comerciales.md). */
export const PROMEDIO_DESCUENTO_ESTUDIANTE = "6,0";
